<loading-indicator loading.bind="router.isNavigating"></loading-indicator>

<import from="./partials/ischeme-header.html"></import>
<import from="./partials/ischeme-footer.html"></import>

<div id="ischemeContainer">

    <main class="scrollContainer" fix-scroll style="height:100vh; overflow-y: scroll;-webkit-overflow-scrolling:touch;">
        <ischeme-header></ischeme-header>
        <div class="container ">

            <div id="form-help" class="popup-add">
                <div id="form-help-container" toggle="active-class: help-active; width-direction: >; width-constraint: 980;">
                    <div class="help-content popup-content">
                        <div class="help-content-wrapper">
                            <span innerhtml.bind="helpHtml"></span>
                        </div>
                    </div>
                    <h2>NEED HELP <span class="help-expand">?</span></h2>
                </div>
            </div>

            <au-viewport></au-viewport>
        </div>

        <div id="mobile-popup"></div>
        <ischeme-footer year="${currentYear}"></ischeme-footer>
    </main>
</div>